/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { Title, DataUtil } from 'plugin/liferay-widgets-react-web';

import { Col, Container, FormControl, FormGroup, FormLabel, Row } from 'external/react-bootstrap';
import { LayerChooser } from '../components/LayerChooser';
import Map from '../components/Map';
import BoundingboxInputPlugin from '../plugins/BoundingboxInputPlugin';

class MapConfigForm extends React.Component {

    constructor(props){
        super(props);
        this.onLayersChange = this.onLayersChange.bind(this);
        this.onBoundingBoxChange = this.onBoundingBoxChange.bind(this);
    }

    componentDidMount(){
        const { formData } = this.props;
        if (!formData.height) {
            this.change({ height: formData.height || 600 });
        }
    }

    onChangeHeight(e){
        this.change({ height: e.target.value });
    }

    onBoundingBoxChange(item){
        this.change({ boundingBox: item });
    }

    onLayersChange(item){
        this.change({ activeLayerUuids: item });
    }

    change(o){
        this.props.onChange({ ...this.props.formData, ...o });
    }

    withCtx(s){
        return this.props.formId + '.' + s;
    }

    render(){
        let { formData, defaultMapConfig } = this.props;
        let mapConfig = DataUtil.asItem(defaultMapConfig);

        return (
            <fieldset>
                <Container className="py-3">
                    <Title title="Konfiguration"/>

                    <Row>
                        <Col xs={12}>
                            <FormGroup controlId="formControlMapBbox">
                                <FormLabel>
                                    Standardkartenausschnitt
                                </FormLabel>
                                <Map
                                    defaultFallbackMapConfigType={'static'}
                                    style={{ height: '365px' }}
                                    zoom={12}
                                    plugins={[BoundingboxInputPlugin]}
                                    boundingBox={formData.boundingBox}
                                    onBoundingBoxChanged={this.onBoundingBoxChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <FormGroup controlId="formControlMapLayers">
                                <FormLabel>
                                    Themen
                                </FormLabel>
                                <div className="layer-chooser">
                                    <LayerChooser
                                        layerDescriptions={mapConfig && mapConfig.children}
                                        onLayersChange={this.onLayersChange}
                                        activeLayerUuids={formData.activeLayerUuids}
                                    />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} sm={4}>
                            <FormGroup controlId="formControlMapHeight">
                                <FormLabel>
                                    Höhe (in Pixel)
                                </FormLabel>
                                <FormControl
                                    type="number"
                                    step="10.0"
                                    value={formData.height}
                                    onChange={this.onChangeHeight.bind(this)}/>
                            </FormGroup>
                        </Col>
                    </Row>
                </Container>
            </fieldset>
        );
    }
}

MapConfigForm.propTypes = {
    formData: PropTypes.object,
    defaultMapConfig: PropTypes.object,
    onChange: PropTypes.func,
    formId: PropTypes.string
};

export default MapConfigForm;



// WEBPACK FOOTER //
// ./js/widgets/MapConfigForm.jsx